import styled from "styled-components";


export const Container = styled.section`
  margin-top: 15rem;
  
  h2{
    text-align: center;
    font-size: 4rem;
    margin-bottom: 3rem;
  }
  .projects{
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    grid-template-rows: auto;
    gap: 2rem;
    padding: 1rem;
    overflow: visible;

    > *{
      min-width: 0;
    }


    .project{
    width: 100%;
    min-width: 0;
    overflow: hidden;
      padding: 2rem 1.8rem;
      background-color: #2b2b2b;
      border-radius: 1.2rem;
      transition: 0.25s;
      display: flex;
      flex-direction: column;
      height: 100%;
      color: #FFF;
      &:hover{
        transform: translateY(-5px);
        background-color: var(--pink);
      }

      header{
        display: flex;
        align-items: center;
        justify-content: space-between;
        color: var(--blue);
        margin-bottom: 3.6rem;
        .project-links{
        
          display: flex;
          flex-wrap: wrap;
          align-items: center;
          gap: 1rem;
        }
        a > img {
          width: 5.0rem;
        }
      }
      
      h3{
        margin-bottom: 2rem;
        color: var(--green);
        transition: color 0.25s;
      }

      p.detail{
        margin-bottom: 1.2rem;
      }

      .label{
        font-weight: 700;
        transition: color 0.25s;
        &.problem{ color: #ff8a65; }
        &.solved{ color: #5eb8ff; }
        &.login{ color: #ffd54f; }
        &.ai{ color: #c792ea; }
      }

      &:hover{
        h3, .label{
          color: #fff;
        }
      }

      p{
        letter-spacing: 0.12rem;
        margin-bottom: 2rem;
        overflow-wrap: anywhere;
        a{
          color: #FFFF;
          border-bottom: 1px solid var(--green);
          transition: color 0.25s;
          &:hover{
            color: var(--green);
          }
        }
      }

      footer{
        margin-top: auto;
        .tech-list{
          display: flex;
          flex-wrap: wrap;
          align-items: center;
          gap: 0.8rem 2rem;
          font-size: 1.4rem;
          opacity: 0.6;
        }
      }

    }
  }

  @media (max-width: 960px){
    .projects{
      grid-template-columns: 1fr 1fr;
    }
      
  }

  @media (max-width: 740px){
    .projects{
      grid-template-columns: 1fr;
    
    }
     .projects{
    padding-right: 1rem;
    gap: 2rem;
    padding: 1rem;
    overflow: hidden;

    .project{
      padding: 1.5rem 1rem;
      background-color: #2b2b2b;
      border-radius: 1.2rem;
      transition: 0.25s;
      display: flex;
      flex-direction: column;
      min-height: 33rem;
      max-height: auto;
      width: 100%;
      color: #FFF;
      &:hover{
        transform: translateY(-5px);
        background-color: var(--pink);
      }

      header{
        display: flex;
        align-items: center;
        justify-content: space-between;
      
        color: var(--blue);
        margin-bottom: 3.5rem;
        .project-links{
          display: flex;
          align-items: center;
          gap: 1rem;
        }
        a > img {
          width: 5.0rem;
        }
      }
      
      h3{
        margin-bottom: 2rem;
      }

      p{
        letter-spacing: 0.091rem;
        margin-bottom: 2rem;
        font-size: 1.4rem;
        a{
          color: #FFFF;
          border-bottom: 1px solid var(--green);
          transition: color 0.25s;
          &:hover{
            color: var(--green);
          }
        }
      }

      footer{
        margin-top: auto;
       
        .tech-list{
          display: flex;
          flex-wrap: wrap;
          width: 100%;
          align-items: center;
          gap: 1.3rem;
          font-size: 1.3rem;
          opacity: 0.6;
        }
      }

    }
  }
`